import { render, staticRenderFns } from "./recuperar.vue?vue&type=template&id=5ef50346&"
import script from "./recuperar.vue?vue&type=script&lang=js&"
export * from "./recuperar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RecoveryPasswordForm: require('/home/runner/work/lareverde-shop/lareverde-shop/components/forms/RecoveryPasswordForm.vue').default})
